import React, { useEffect, useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import PaymentAcknowledge from "../../../../_shared/PaymentAcknowledge/PaymentAcknowledge";
import SubFooter from "../../components/subFooter/subFooter";
import PaymentGateway from "../../../../_shared/PaymentGateway/PaymentGateway";
import { renewalActions } from "../../../../redux/actions";
import PaymentWrapper from "./Payment.style";
import { config as globalConfig } from "../../../../config";
import motor from "../../../../assets/images/icons/motor.svg";
import { Dialog } from "primereact/dialog";

// import { useNavigate } from "react-router-dom";
import * as utils from "../../helpers/utils";
import * as globalUtils from "../../../../helpers/utils";
import {
  createTamaraSession,
  getCardPayment,
  getSadadPayment,
} from "../../../../services/renewal-service";
import config from "../../helpers/renewal.config";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import {
  getApplePayPayments,
  getApplePayPaymentsAPI,
  getApplePaySessionAPI,
  getPaymentOptionsTamara,
} from "../../../../services/common";
const Payment = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const locDetails = location?.state?.quotationDataResponse;
  const [ackAgree, setAckAgree] = useState(true);
  const [payLoading, setPayLoading] = useState(false);
  const quotationData = useSelector((state) => state.renewal.quotationDetails);
  const proposalData = useSelector((state) => state.renewal.proposalDetails);
  const quotationDataPrepared = utils.prepareQuotationData(quotationData);
  const uid = useSelector((state) => state.renewal.uid);
  const { i18n, t } = useTranslation();
  const [emailDialog, setEmailDialog] = useState(false);
  const [splitPayment, setSplitPayment] = useState();
  const [optionsTamara, setOptionsTamara] = useState();
  const [showTamra, setShowTamra] = useState(true);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.email) {
        errors.email = t("Email_is_required");
      } else if (!globalUtils.isValidEmail(data.email)) {
        errors.email = t("Invalid_email_address") + "E.g. example@email.com";
      }
      return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (data) => {
      tamaraCreateSession(data.email);
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  // const chosenProductCode = useSelector((state) => state.renewal.chosenProductCode);
  const [quotationDataResponse, setQuotationDataResponse] = useState(
    locDetails ? locDetails : quotationData
  );
  const dispatch = useDispatch();

  const toast = useRef(null);

  const updateLoaderValue = (value) => {
    dispatch(renewalActions.updateLoading(value));
  };

  const getSummary = () => {
    return quotationDataResponse.priceDetails.priceDetailsArray.map((ele) => {
      return {
        title: ele.priceName,
        price: ele.priceValue,
        code: ele.priceCode,
      };
    });
  };

  useEffect(() => {
    // for tamara options
    const tamaraRequest = {
      idNumber: quotationDataPrepared?.idNumber,
      quotationNumber: quotationDataResponse?.quotationNumber,
      totalAmount: quotationDataResponse?.premium,
      systemId: "MOTOR",
      mobileNumber: globalUtils.prepareMobileNumber(
        quotationDataPrepared.customerDetails.mobile,
        true
      ),
      email: quotationDataPrepared?.customerDetails.email,
      langCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
    };

    getPaymentOptionsTamara(tamaraRequest)
      .then((res) => {
        const response = res.data;
        if (response.resultCode === "S") {
          setOptionsTamara([
            ...response.paymentOptions.available_payment_labels,
          ]);
          setSplitPayment(
            response.paymentOptions.available_payment_labels[0].instalment
          );
          setShowTamra(response.paymentOptions?.has_available_payment_options)
        }else{
          setShowTamra(false)

        }
      })
      .catch( e=> {setShowTamra(false)})
      .finally();
  }, [, quotationData, quotationDataResponse]);

  const applePayHandler = () => {
    try {
      setPayLoading(false);
      var request = {
        countryCode: "SA",
        currencyCode: "SAR",
        supportedNetworks: ["masterCard", "visa", "mada", "discover", "amex"],
        merchantCapabilities: ["supports3DS"], // [ 'supports3DS', 'supportsCredit', 'supportsDebit' ],
        total: {
          label: "Motor Insurance",
          amount: quotationDataResponse?.premium.toString(),
        },
      };
      var appleSession = new window.ApplePaySession(12, request);
      appleSession.onvalidatemerchant = async (event) => {
        let requestData = {
          sessionRequest: {
            systemId: "MOTOR",
            domain: window.location.hostname,
            customer: {
              idNo: quotationDataPrepared.idNumber,
              mobile: quotationDataPrepared.customerDetails.mobile,
              email: quotationDataPrepared.customerDetails.email,
              passportNo: "",
            },
            quote: {
              amount: quotationDataResponse?.premium,
              quotationNo: quotationDataResponse.quotationNumber,
              policyNo: "",
            },
            lang: globalUtils.getOneLetterLanguageCode(props.i18n.language),
            channelCode: "PORTAL",
          },
        };
        //API Call
        getApplePaySessionAPI(requestData)
          .then((response) => {
            if (response?.data?.sessionResponse?.resultCode === "S") {
              const sessionData =
                response?.data?.sessionResponse?.sessionDetails;
              appleSession.completeMerchantValidation(sessionData);
            } else {
              const resultMessage =
                response?.data?.sessionResponse?.resultMessage ||
                "Sorry for not complete your request.";
              appleSession.abort();
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: resultMessage,
                life: 6000,
              });
            }
          })
          .catch((error) => {
            appleSession.abort();
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail:
                error?.message || "There Are Technical Issue In First Step.",
              life: 6000,
            });
          });
      };

      appleSession.onpaymentauthorized = async (event) => {
        const applePaymentTokenData = event.payment.token.paymentData;
        const requestData = {
          paymentRequest: {
            systemId: "MOTOR",
            domain: window.location.hostname,
            customer: {
              idNo: quotationDataPrepared.idNumber,
              mobile: quotationDataPrepared.customerDetails.mobile,
              email: quotationDataPrepared.customerDetails.email,
              passportNo: "",
            },
            quote: {
              amount: quotationDataResponse?.premium,
              quotationNo: quotationDataResponse.quotationNumber,
              policyNo: "",
            },
            token: {
              version: applePaymentTokenData.version,
              data: applePaymentTokenData.data,
              signature: applePaymentTokenData.signature,
              header: {
                ephemeralPublicKey:
                  applePaymentTokenData.header.ephemeralPublicKey,
                publicKeyHash: applePaymentTokenData.header.publicKeyHash,
                transactionId: applePaymentTokenData.header.transactionId,
              },
            },
            lang: globalUtils.getOneLetterLanguageCode(props.i18n.language),
            channelCode: "PORTAL",
          },
        };
        //API CALL
        getApplePayPaymentsAPI(requestData)
          .then((resonseData) => {
            if (
              resonseData?.data?.paymentResponse?.resultCode == "S" &&
              resonseData?.data?.paymentResponse?.policyDetails?.policyNumber
            ) {
              appleSession.completePayment(
                window.ApplePaySession.STATUS_SUCCESS
              );
              const successPolicyNumber =
                resonseData?.data?.paymentResponse?.policyDetails?.policyNumber;
              localStorage.setItem("policyNoOld", successPolicyNumber);
              window.location.href = config.paymentSuccessRedirect;
            } else {
              appleSession.completePayment(
                window.ApplePaySession.STATUS_FAILURE
              );
              const resultMessage =
                resonseData?.data?.paymentResponse?.resultMessage ||
                "Sorry for not complete your payment request.";
              appleSession.abort();
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: resultMessage,
                life: 6000,
              });
              // window.lmSMTObj.track("purchaseCompleted", {
              //   paymentSuccessful: "Fail",
              //   productName: "Motor",
              //   subProductName: quotationDetails?.productCode,
              //   price: +quotationDetails?.premium,
              //   currency: "SAR",
              // });
              // window.location.href = `${window.location.hostname.includes('telebit') ? '/#' : '/product/#'}/motor/failed`;
            }
          })
          .catch((error) => {
            appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail:
                error?.message || "There Are Technical Issue In Second Step.",
              life: 6000,
            });
            // window.lmSMTObj.track("purchaseCompleted", {
            //   paymentSuccessful: "Fail",
            //   productName: "Motor",
            //   subProductName: quotationDetails?.productCode,
            //   price: +quotationDetails?.premium,
            //   currency: "SAR",
            // });
            // window.location.href = `${window.location.hostname.includes('telebit') ? '/#' : '/product/#'}/motor/failed`;
          });
      };

      appleSession.oncancel = function (event) {
        //console.log('oncancel : ', event);
        //const sessionErrorCode = event.sessionError.code;
        //  console.log('sessionErrorCode 10 : ', sessionErrorCode);
        //  if (sessionErrorCode) {
        //   let defaultMsg = 'Apple Pay Session Error Code (' + sessionErrorCode + ').';
        //   if (sessionErrorCode === 'shippingContactInvalid') {
        //     defaultMsg = 'The code that indicates that the shipping address or contact information is invalid or missing.';
        //   } else if (sessionErrorCode === 'billingContactInvalid') {
        //     defaultMsg = 'The code that indicates that the billing address information is invalid or missing.';
        //   } else if (sessionErrorCode === 'addressUnserviceable') {
        //     defaultMsg = 'The code that indicates that the merchant can’t provide service to the shipping address.';
        //   } else if (sessionErrorCode === 'couponCodeInvalid') {
        //     defaultMsg = 'The code that indicates an invalid coupon.';
        //   } else if (sessionErrorCode === 'couponCodeExpired') {
        //     defaultMsg = 'The code that indicates an expired coupon.';
        //   } else if (sessionErrorCode === 'unknown') {
        //     defaultMsg = 'The code that indicates an unknown but nonfatal error occurred during payment processing. The user can attempt authorization again.';
        //   }
        //   toast.current.show({
        //     severity: "error",
        //     summary: "Apple Pay Error",
        //     detail: defaultMsg,
        //     life: 10000,
        //   });
        //  }
        //  setaAplePayData({
        //   sessionErrorCode: sessionErrorCode,
        //   oncancel: event
        // });
      };
      appleSession.begin();
    } catch (e) {
      //console.log("startApple-error : ",e);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: e?.message || "There Are Issue.",
        life: 6000,
      });
    }
  };

  const creditCardTokenHandler = (token) => {
    setPayLoading(true);
    const data = {
      passportNo: "",
      amount: quotationDataResponse.premium,
      "3ds": {
        enabled: "true",
      },
      systemId: "MOTOR",
      mobile: quotationDataPrepared.customerDetails.mobile,
      capture: "true",
      policyNo: "",
      source: {
        token: token,
      },
      idNo: quotationDataPrepared.idNumber,
      quotationNo: quotationDataResponse.quotationNumber,
      reference: "xxxx",
      currency: "SAR",
      risk: {
        enabled: "true",
      },
      failure_url: config.paymentFailedRedirect,
      lang: globalUtils.getOneLetterLanguageCode(props.i18n.language),
      email: quotationDataPrepared.customerDetails.email,
      success_url: config.paymentSuccessKitCredit,
    };
    addPaymentInfoTagging("Credit Card");
    getCardPayment(data)
      .then((response) => {
        const res = response.data;
        localStorage.setItem("checkoutId", res.id);
        // navigate(config.paymentFailedRedirect, {
        //   replace: true,
        //   state: { checkoutId: res.id},
        // });

        purchasesTagging("Credit Card", res.id);
        window.location.href = res.getCardPaymentResponse._links.redirect.href;
      })
      .catch((err) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: uid
            ? "Motor Insurance Renew Direct Link"
            : "Motor Insurance Renew",
          funnel_step: uid ? "step_3" : "step_7",
          error_messages: JSON.stringify(err),
        });
        window.location.href = config.paymentFailedRedirect;
        // navigate(config.paymentFailedRedirect, { replace: true });
      })
      .finally((e) => {
        setTimeout(() => {
          setPayLoading(false);
        }, 3000);
      });
  };

  const sadadHandler = () => {
    setPayLoading(true);
    const data = {
      motorRequest: {
        endtType: "PSL",
        quotationNumber: quotationDataResponse.quotationNumber,
        idNumber: quotationDataPrepared.idNumber,
      },
      source: "MOTOR",
    };
    addPaymentInfoTagging("Sadad");
    getSadadPayment(data)
      .then((response) => {
        const res = response.data;
        setPayLoading(false);
        if (res.resultCode === "S") {
          purchasesTagging("Sadad", res.billNo);

          navigate(config.paymentSuccessKitSadad, {
            replace: true,
            state: {
              billNumber: res.billNo,
              billExpiryDate: res.billExpiryDate,
              amount: quotationDataResponse.premium,
              policyNumber: res.policyNumber,
            },
          });
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: uid
              ? "Motor Insurance Renew Direct Link"
              : "Motor Insurance Renew",
            funnel_step: uid ? "step_3" : "step_7",
            error_messages: res.resultMessage,
          });
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: res.resultMessage,
            life: 6000,
          });
          window.location.href = config.paymentFailedRedirect;
          // navigate(config.paymentFailedRedirect, { replace: true });
        }
      })
      .catch((err) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: uid
            ? "Motor Insurance Renew Direct Link"
            : "Motor Insurance Renew",
          funnel_step: uid ? "step_3" : "step_7",
          error_messages: JSON.stringify(err),
        });
        setPayLoading(false);
        navigate(config.paymentFailedRedirect, { replace: true });
      });
  };

  const tamaraCreateSession = (newEmail) => {
    setPayLoading(true);
    const data = {
      quotationNumber: quotationDataResponse.quotationNumber,
      totalAmount: quotationDataResponse.premium,
      systemId: "MOTOR",
      endorsementType: "PSL",
      mobileNumber: quotationDataPrepared.customerDetails.mobile,
      langCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
      links: {
        success: { url: config.paymentSuccessKitCredit + "?" },
        failure: { url: config.paymentFailedRedirect + "?" },
        // "success" : {
        //   "url" : "https://liferay-web-uat.tawn.com/web/store/onlinepayment?policyType=motor"
        // },
        // "failure" : {
        //   "url" : "https://liferay-web-uat.tawn.com/web/store/onlinepayment?policyType=motor"
        // }
      },

      idNumber: quotationDataResponse.idNumber,
      email: quotationDataPrepared.customerDetails.email || newEmail,
      channelCode: "85",
      installments: splitPayment
      // failure_url: config.paymentFailedRedirect,
      // success_url: config.sadadSuccessRedirect,
    };
    addPaymentInfoTagging("Sadad");

    createTamaraSession(data)
      .then((response) => {
        const res = response.data;
        if (res.resultCode === "S") {
          purchasesTagging("Tamara", res.refId);
          localStorage.setItem("tamaraResponse", JSON.stringify(res));
          window.location.href = res.redirectUrl;
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: uid
              ? "Motor Insurance Renew Direct Link"
              : "Motor Insurance Renew",
            funnel_step: uid ? "step_3" : "step_7",
            error_messages: res.resultMessage,
          });
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: res.resultMessage,
            life: 6000,
          });
          // navigate( data.failure_url, { replace: true });
        }
      })
      .catch((err) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: uid
            ? "Motor Insurance Renew Direct Link"
            : "Motor Insurance Renew",
          funnel_step: uid ? "step_3" : "step_7",
          error_messages: JSON.stringify(err),
        });
        navigate(data.failure_url, { replace: true });
      })
      .finally((e) => {
        setTimeout(() => {
          setPayLoading(false);
        }, 3000);
      });
  };

  const tamaraHandler = () => {
    if (!quotationDataPrepared.customerDetails.email) {
      setEmailDialog(true);
    } else {
      tamaraCreateSession();
    }
  };

  useEffect(() => {
    updateLoaderValue(payLoading);
  }, [payLoading]);

  async function hash(email) {
    const utf8 = new TextEncoder().encode(email);
    const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, "0"))
      .join("");
    return hashHex;
  }

  const addPaymentInfoTagging = (payType) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "add_payment_info",
      ecommerce: {
        funnel_step: uid ? "step_3" : "step_7",
        step_name: uid
          ? "motor_policy_directLink_renewal_payment_initiate"
          : "motor_insurance_login_renew_add_payment_info",
        items: [
          {
            item_name: uid
              ? "Motor Insurance Direct Link Renew"
              : "Motor Insurance Login Renew",
            item_category: "Motor Insurance",
            total_premium: parseFloat(quotationDataResponse.premium),
            item_class: "Individual",
            data_retrieval_method: "Registration Card",
            payment_method: payType,
            is_car_owner: "Yes",
            vehicle_year:
              quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                ?.yearOfManufacture,
            vehicle_brand:
              quotationData?.vehicleDetails?.vehicleDetailsArray[0]?.makeName,
            vehicle_model:
              quotationData?.vehicleDetails?.vehicleDetailsArray[0]?.modelName,
            driver_yob:
              quotationData?.customerDetails?.policyHolder[0]?.gregDob,
            effective_date: quotationDataResponse.inceptionDate,
            sha_256_email: hash(quotationDataPrepared.customerDetails.email),
            sha_256_phone: hash(quotationDataPrepared.customerDetails.mobile),
            policy_id: quotationDataResponse?.quotationNumber,
            addons: [
              {
                name: quotationDataResponse.productCode,
                id: quotationDataResponse.idNumber,
                item_category: "Motor Insurance",
                price: parseFloat(
                  quotationDataResponse?.priceDetails?.priceDetailsArray?.find(
                    (i) => i.priceCode === "TOTC"
                  )?.priceValue
                ),
              },
            ],
          },
        ],
      },
    });
  };

  const purchasesTagging = (payType, transaction_id) => {
    let checkout = {
      event: "purchase",
      ecommerce: {
        transaction_id: transaction_id,
        value: parseFloat(quotationDataResponse.premium),
        tax:
          parseFloat(
            quotationDataResponse?.priceDetails?.priceDetailsArray?.find(
              (i) => i.priceCode === "VAT"
            )?.priceValue
          ) || parseFloat((quotationDataResponse.premium * 15) / 100),
        shipping: 0.0,
        currency: "SAR",
        coupon: "",
        payment_method: payType,
        funnel_step: uid ? "step_4" : "step_8",
        step_name: uid
          ? "motor_policy_direct_link_renew_purchased"
          : "motor_insurance_login_Renew_purchase",
        policy_id: quotationDataResponse?.quotationNumber,
        items: [
          {
            item_name: uid
              ? "Motor Insurance Direct Link Renew"
              : "Motor Insurance Login Renew",
            item_category: "Motor Insurance",
            item_class: "Individual",
            price: parseFloat(quotationDataResponse.premium),
            quantity:
              quotationData?.vehicleDetails?.vehicleDetailsArray?.length,
            data_retrieval_method: "Registration Card",
            is_car_owner: "Yes",
            vehicle_year:
              quotationData?.vehicleDetails?.vehicleDetailsArray[0]
                ?.yearOfManufacture,
            vehicle_brand:
              quotationData?.vehicleDetails?.vehicleDetailsArray[0]?.makeName,
            vehicle_model:
              quotationData?.vehicleDetails?.vehicleDetailsArray[0]?.modelName,
            driver_yob:
              quotationData?.customerDetails?.policyHolder[0]?.gregDob,
            effective_date: quotationDataResponse.inceptionDate,
            sha_256_email: hash(quotationDataPrepared.customerDetails.email),
            sha_256_phone: hash(quotationDataPrepared.customerDetails.mobile),
            addons: [
              {
                name: quotationDataResponse.productCode,
                id: quotationDataResponse.idNumber,
                item_category: "Motor Insurance",
                price: parseFloat(
                  quotationDataResponse?.priceDetails?.priceDetailsArray?.find(
                    (i) => i.priceCode === "TOTC"
                  )?.priceValue
                ),
              },
            ],
          },
        ],
      },
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(checkout);
    payType === "Credit Card" &&
      localStorage.setItem("checkout", JSON.stringify(checkout));
  };

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "payment_initiate",
      ecommerce: {
        funnel_step: uid ? "step_2" : "step_6",
        step_name: uid
          ? "motor_policy_directLink_renewal_payment_initiate"
          : "motor_insurance_login_renew_payment_initiate",
        items: [
          {
            item_name: uid
              ? "Motor Insurance Direct Link Renew"
              : "Motor Insurance Login Renew",
            item_category: "Motor Insurance",
            item_class: "Individual",
          },
        ],
      },
    });
  }, []);

  const renderFooter = () => {
    return (
      <div className="w-100 d-flex flex-row-reverse">
        <Button
          label={t("Add_Email")}
          icon="pi pi-check"
          onClick={formik.submitForm}
          autoFocus
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <PaymentWrapper>
        <div className="container">
          <div className="row my-5">
            <div className="col-md-3">
              <h2>{props.i18n.t("acknowledgeAgreement")}</h2>
            </div>
            <div className="col-md-9">
              <PaymentAcknowledge setAckAgree={setAckAgree} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <h2>{props.i18n.t("choosePaymentMethod")}</h2>
            </div>
            <div className="col-md-9">
              <PaymentGateway
                tamaraCreateSession={tamaraHandler}
                paymentOptions={[
                  globalConfig.paymentOptions.CREDIT_CARD,
                  globalConfig.paymentOptions.SADAD,
                  globalConfig.paymentOptions.TAMARA,
                  globalConfig.paymentOptions.APPLE,
                ]}
                creditCardToken={creditCardTokenHandler}
                sadadHandler={sadadHandler}
                creditCardLoading={payLoading}
                ackAgree={ackAgree}
                totalAmount={quotationDataResponse.premium}
                applePayHandler={applePayHandler}
                splitPayment={splitPayment}
                setSplitPayment={setSplitPayment}
                optionsTamara={optionsTamara}
                showTamra
              />
            </div>
          </div>
        </div>
      </PaymentWrapper>
      <SubFooter showPayNow={false} total={quotationDataResponse.premium} />

      {/**
       * Email Dialog
       */}
      <Dialog
        header={t("Enter_Your_Email")}
        visible={emailDialog}
        style={{ width: "50vw" }}
        onHide={() => setEmailDialog(false)}
        footer={renderFooter()}
        className={i18n.language === "ar" ? "ar" : ""}
      >
        <div className="row">
          <div className="col-12">
            <p>{t("Enter_Your_Email_For_Tamara")}</p>
          </div>
          <div className="col-md-12">
            <div className="field text-initial">
              <InputText
                name="email"
                keyfilter="email"
                className={`form-control ${classNames({
                  "p-invalid": isFormFieldValid("email"),
                  lato: formik.values.email,
                })}`}
                placeholder={t("email")}
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {getFormErrorMessage("email")}
            </div>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default withTranslation()(Payment);
